import React, { useEffect, useRef, useState } from 'react';
import { Table } from '../../components/Table/Table';
import { edit_icon, no_image, search_icon } from '../../assets/imgs';
import { Location_list } from '../../screens/redux/api/dummyJson';
import { useCityEditMutation, useDropDownLocationListMutation, useLazyCityListQuery, useLazyCityListViewQuery, useLazyLocationListQuery, useLocationListMutation, useLocationsEditMutation } from '../../screens/redux/api/api';
import { useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import { Cropper } from 'react-cropper';
import { toast } from 'react-toastify';
import Select from 'react-select';

const City = ({ list, setPageno, pagecount, setPagecount, countryList, locationsApi }) => {
    const [popup, setPopup] = useState(false);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [image, setImage] = useState(null); // State for the selected image
    const [croppedImage, setCroppedImage] = useState(null); // State for the cropped image
    const cropperRef = useRef(null); // Ref for the Cropper component
    const fileInputRef = useRef(null); // Ref for the file input
    const [name, setName] = useState();
    const [id, setId] = useState();
    const [parentId, setParentId] = useState();
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [country, setCountry] = useState()
    const [state, setState] = useState();
    const [stateList, setStateList] = useState([]);
    const [cityList, setcityList] = useState([]);
    const [height, setHeight] = useState(false)
    console.log(country, "country check")

    const [dropDownLocationList] = useDropDownLocationListMutation();
    const [cityViewApi] = useLazyCityListViewQuery();
    const [cityEditApi] = useLocationsEditMutation();

    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))
    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result); // Set the selected image for cropping
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle image cropping
    const handleCrop = () => {
        if (cropperRef.current) {
            const cropper = cropperRef.current.cropper;
            const croppedImageUrl = cropper.getCroppedCanvas().toDataURL(); // Get cropped image as data URL
            fetch(croppedImageUrl)
                .then((res) => res.blob())
                .then((blob) => {
                    const file = new File([blob], "File name", { type: "image/png" });
                    setCroppedImage(file); // Set the cropped image
                });
            setImage(null); // Close the cropper after cropping
            setHeight(false);
        }
    };


    const locationLists = (type, id, search) => {
        const formdata = new FormData();
        formdata.append("type", type)
        if (type != 1) {
            formdata.append("parent_id", id)
        }
        if (search) {
            formdata.append('search', search)
        }
        dropDownLocationList(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let arr = res?.data?.map((item, ind) => {
                    let obj = {}
                    obj.value = item.id
                    obj.label = item.name
                    return obj;
                })
                if (type == 2) {
                    setStateList(arr)
                } else if (type == 3) {
                    setcityList(arr)
                }
                // setList(res?.data?.data);

            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const cityListView = (id) => {
        cityViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res city", res);
                if (res?.data) {
                    setPopup(true);
                    // setType("edit");
                    locationLists(2, res?.data?.country?.id)
                    setCountry({ value: res?.data?.country?.id, label: res?.data?.country?.name })
                    setState({ value: res?.data?.state?.id, label: res?.data?.state?.name })
                    setName(res?.data?.city?.name);
                    setCroppedImage(res?.data?.city?.image);
                    setLatitude(res?.data?.city?.place_coordinates?.latitude);
                    setLongitude(res?.data?.city?.place_coordinates?.longitude);
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const cityEdit = () => {
        const formdata = new FormData();
        formdata.append("type", 3);
        formdata.append("name", name);
        formdata.append("country_id", country?.value);
        formdata.append("state_id", state?.value);
        formdata.append("id", id);
        // formdata.append("parent_id", parentId?.parent_id);
        formdata.append("latitude", latitude);
        formdata.append("longitude", longitude);
        if (croppedImage?.name) {
            formdata.append("image", croppedImage);
        }
        setLoader(true);
        cityEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    setLoader(false);
                    setPopup(false);
                    toast.success(res?.message);
                    setName("");
                    setLatitude("");
                    setLongitude("");
                    setCroppedImage(no_image);
                    locationsApi();
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }



    useEffect(() => {
        if (id) {
            cityListView(id);
        }
    }, []);



    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            // {
            //     Header: "Area",
            //     accessor: "area",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            {
                Header: "City",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            // {
            //     Header: "Country",
            //     accessor: "country",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            // {
            //     Header: "State",
            //     accessor: "state",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            {
                Header: "Image",
                accessor: "image",
                Cell: ({ value, row }) => {
                    return <img src={value} style={{ height: "50px", width: "70px", borderRadius: "5px" }} />;
                },
            },
            {
                Header: "Action",
                accessor: "property",
                Cell: ({ value, row }) => {
                    return <React.Fragment>
                        <div className="d-flex ac-jc">
                            {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                                <button
                                    onClick={() => { cityListView(row?.original?.id); setId(row?.original?.id); setParentId(row?.original) }}
                                    className="cust-btn "
                                >
                                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                </button>}
                            {/* <button
                                onClick={() => setDeletePopup(row.original.id)}
                                className="cust-btn "
                            >
                                <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                            </button> */}
                        </div>
                    </React.Fragment >
                },
            },

        ],
        []
    );

    return (
        <div className="">
            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
            {popup && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new"
                        style={{
                            height: height == true ? '580px' : '450px'
                        }}
                    >
                        <div className='d-flex ac-jb' >
                            <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                                Edit City
                            </h4>
                            <button className='cust-btn' onClick={() => { setPopup(false); setName(""); setCroppedImage(null); setImage(""); setLoader(false) }}>
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Country
                        </h4>
                        <Select
                            className='input-pop_box'
                            options={countryList}
                            value={country}
                            onChange={(e) => { setCountry(e); locationLists(2, e.value) }}
                        />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            State
                        </h4>
                        <Select
                            className='input-pop_box'
                            options={stateList}
                            value={state}
                            onChange={(e) => { setState(e); locationLists(3, e.value) }}
                        />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            City
                        </h4>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Name" />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Latitude
                        </h4>
                        <input type="number" value={latitude} onChange={(e) => setLatitude(e.target.value)} className="input-pop ps-2 w-100" placeholder="Latitude" />
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Longitude
                        </h4>
                        <input type="number" value={longitude} onChange={(e) => setLongitude(e.target.value)} className="input-pop ps-2 w-100" placeholder="Longitude" />
                        <div className='d-flex ac-jb mt-3'>
                            <div className='w-50'>
                                <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                    Image
                                </h4>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    ref={fileInputRef} // Use the ref here
                                />
                                <button
                                    className="upload-btn f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mb-3"
                                    onClick={() => { fileInputRef.current.click(); setHeight(true) }}
                                >
                                    Select Image
                                </button>
                            </div>
                            <div className='w-50'>
                                {image && (
                                    <div>
                                        <Cropper
                                            ref={cropperRef}
                                            src={image}
                                            aspectRatio={1} // Square aspect ratio
                                            guides={false}
                                            viewMode={1}
                                            autoCropArea={1}
                                            background={false}
                                            responsive={true}
                                            style={{ height: 300, width: '100%' }} // Ensure the cropper has a defined size
                                        />
                                        <button
                                            className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                                            onClick={handleCrop}
                                        >
                                            Crop Image
                                        </button>
                                    </div>
                                )}
                                {console.log(croppedImage, "cropped image", croppedImage)}
                                <img onChange={(e) => setCroppedImage(e.target.value)}
                                    src={croppedImage ? croppedImage?.name ? URL.createObjectURL(croppedImage) : croppedImage : no_image}
                                    style={{
                                        width: '150px',
                                        height: '150px',
                                        margin: '10px 0px',
                                    }}
                                    alt="Cropped"
                                />
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button onClick={() => cityEdit()} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3">
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )} Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default City